<template>
  <van-popup v-model="show" :close-on-click-overlay="false">
    <div class="content">
      <img :src="$options.imgObj.close" alt="" class="close" @click="close" />
      <img :src="$options.imgObj.course" alt="" class="course" />
      <img :src="$options.imgObj.btn3" alt="" class="btn3" @click="confirm" />
    </div>
  </van-popup>
</template>

<script>
export default {
  name: 'PurchaseCourse',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  imgObj: {
    course: require('paintingCompetition/assets/popup/course.png'),
    btn3: require('paintingCompetition/assets/popup/btn3.png'),
    close: require('paintingCompetition/assets/common/close.png')
  },
  methods: {
    close() {
      this.$parent.closePurchaseCourse()
    },

    confirm() {
      this.$parent.purchaseCourse()
    }
  }
}
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
.van-popup {
  background-color: transparent;
  overflow: visible;
}
.content {
  .close {
    width: 56px;
    height: 56px;
    position: absolute;
    right: -15px;
    top: -86px;
  }
  .course {
    width: 624px;
  }
  .btn3 {
    width: 353px;
    height: 109px;
    position: absolute;
    bottom: -49px;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
